export function isIntegrationBuildRequest(config) { return Boolean(config && config.integrationBuildRequest) }
const messages = {
  EO_USER_REQUIRED: '登录身份已失效，请重新登录', EO_RESOURCE_DENIED: '未分配此操作权限',
  EO_APP_SCOPE_UNCONFIGURED: '应用授权组件不可用', EO_APP_DENIED: '无权访问该应用',
  EO_INVALID_REQUEST: '申请参数不正确', EO_APP_PENDING: '应用正在审核，仅可查看记录',
  EO_APP_STATE_DENIED: '当前应用状态不允许申请', EO_APP_NOT_FOUND: '应用不存在或已删除',
  EO_DISABLED: '生成服务暂未开放', EO_NOT_CONFIGURED: '生成条件尚未就绪，请联系管理员',
  EO_BUSY: '生成任务排队已满，请等待已有任务完成后重试',
  EO_STORAGE_FULL: '生成文件存储空间不足，请联系管理员清理历史记录或扩容',
  EO_WORKSPACE_FULL: '生成工作空间不足，请联系管理员处理', EO_NOT_FOUND: '未找到对应记录',
  EO_AMBIGUOUS_REQUEST: '申请关联需人工核实', EO_EXECUTION_STOPPED: '生成已暂停，请联系管理员',
  EO_READ_FAILED: '记录读取失败，请稍后刷新'
}
export function integrationBuildError(body, status) {
  const code = body && body.data && body.data.code
  const unauthorized = status === 401 || (body && body.code === 401)
  const forbidden = status === 403 || (body && body.code === 403)
  const safe = unauthorized ? 'EO_USER_REQUIRED' : forbidden ? 'EO_RESOURCE_DENIED' : code
  return { code: messages[safe] ? safe : 'EO_OPERATION_UNKNOWN', unauthorized, forbidden,
    unknown: !messages[safe], message: messages[safe] || '结果暂未确认，请刷新核实，不要重复申请' }
}



// WEBPACK FOOTER //
// ./src/utils/integrationBuildRequest.js